import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { UiModule } from 'src/app/ui/ui.module';
import {
  ModalTemplateComponent,
  PencilModalSizeEnum,
} from '../modal-template/modal-template.component';
import { LoadingV2Component } from '../../loading-v2/loading-v2.component';
interface SpinnerModalData {
  title?: string;
  description?: string;
}

@Component({
  selector: 'app-spinner-modal',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    ModalTemplateComponent,
    UiModule,
    LoadingV2Component,
  ],
  templateUrl: './spinner-modal.component.html',
  styleUrls: ['./spinner-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  // encapsulation: ViewEncapsulation.None,
})
export class SpinnerModalComponent {
  title?: string;
  description?: string;
  readonly pencilModalSizeEnum = PencilModalSizeEnum;

  constructor(
    public dialogRef: MatDialogRef<SpinnerModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SpinnerModalData,
  ) {
    this.title = data?.title;
    this.description = data?.description;

    // Disable closing by clicking outside or pressing escape
    this.dialogRef.disableClose = true;
  }
}
